import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio/ngx';
import { Keychain } from '@ionic-native/keychain/ngx';
declare var window;

@Injectable({
    providedIn: 'root'
})
export class UtilService {
    isIos: boolean;
    isMobile: boolean;
    constructor(private platform: Platform, private storage: Storage,
                private fingerPrintAIO: FingerprintAIO, private keychain: Keychain) {
        if (this.platform.is('cordova')) {
            this.isMobile = true;
            if (this.platform.is('ios')) {
            this.isIos = true;
          } else {
              this.isIos = false;
          }
        } else {
            this.isMobile = false;
        }
    }

    isIosDevice() {
        return this.platform.is('ios');
    }
    isFingerprintAvailable() {
        let result = false;
        const promise = this.fingerPrintAIO.isAvailable();
        promise.then((response) => {
            alert('reponse of FP::'+ response);
            result = true;
           });
        promise.catch((error) => {
            alert('err of FP::'+ error);
                        result  = false;
        });
        return result;
      }
      showFingerPrint() {
        return this.fingerPrintAIO.show({
          title: 'Driver Insights Biometrisches Einloggen',
          subtitle: 'Auf diese Weise können Sie sich mit Ihrem Fingerabdruck anmelden',
          description: 'Berühren Sie den Fingerabdrucksensor',
          disableBackup : true,
          cancelButtonTitle : 'ABBRECHEN'
        });
      }

    iskeyAvailable() {
        if (this.isIosDevice()) {
            return this.keychain.get('DIBiometricCreds');
        } else {
            return this.storage.get('DIBiometricCreds');
        }
    }
    saveKey(val) {
        if (this.isIosDevice()) {
            return this.keychain.set('DIBiometricCreds', JSON.stringify(val), false);
        } else {
            return this.storage.set('DIBiometricCreds', JSON.stringify(val));
        }
    }
    deleteKey() {
        if (this.isIosDevice()) {
            return this.keychain.remove('DIBiometricCreds');
        } else {
            return this.storage.remove('DIBiometricCreds');
        }
    }
    setLoggedInStatus() {
        this.storage.set('DIisFirstLogin', 'false');
    }
    getLoggedInStatus() {
        return this.storage.get('DIisFirstLogin');
    }
    deleteStorage() {
        this.storage.remove('DIisFirstLogin');
    }
    setUserOption(userData) {
        this.storage.set('DIoption', JSON.stringify(userData));
    }
    getUserOption() {
        return this.storage.get('DIoption');
    }
    deleteUserOption() {
        this.storage.remove('DIoption');
    }

    storeUserCredentials(credentials) {
        if (this.isIosDevice()) {
            return this.keychain.set('DriverInsightsCredentials', JSON.stringify(credentials), false);
        }
        else {
            return this.storage.set('DriverInsightsCredentials', JSON.stringify(credentials));
        }
    }

    getUserCredentials() {
        if (this.isIosDevice()) {
            return this.keychain.get('DriverInsightsCredentials');
        }
        else {
            return this.storage.get('DriverInsightsCredentials');
        }
    }

    deleteUserCredentials() {
        if (this.isIosDevice()) {
            return this.keychain.remove('DriverInsightsCredentials');
        }
        else {
            this.storage.remove('DriverInsightsCredentials');
        }
    }
}
